export default "https://statics.cloudfastin.top/static/v1.27.38.2/store/images/codedisplay1.png?1eee3ba5f62f2e1adc5d58efd449d632";